import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useUnitPreferences } from '../../hooks/useUnitPreferences';
// Slim always-visible strip pinned above the AccountSection. Hosts the
// app-wide Imperial / Metric switch — flipping it sets a coupled default
// pair (imperial = ft + acres, metric = m + hectares) that Measure, Path,
// Polygon and the rest read from useUnitPreferences.
export const UnitPreferencesFooter = () => {
    const { system, setSystem } = useUnitPreferences();
    return (_jsxs("div", { className: "border-t px-4 py-2 flex items-center justify-between flex-shrink-0", style: { borderColor: 'var(--pewter)', backgroundColor: 'var(--forest)' }, children: [_jsx("span", { className: "text-xs", style: { color: 'var(--dew)' }, children: "Units" }), _jsxs("select", { value: system, onChange: (e) => setSystem(e.target.value), className: "px-2 py-1 rounded text-xs cursor-pointer", style: {
                    backgroundColor: 'var(--pewter)',
                    color: 'var(--sand)',
                    border: '1px solid var(--charcoal)',
                }, title: "Switch the app-wide unit system", children: [_jsx("option", { value: "imperial", children: "Imperial" }), _jsx("option", { value: "metric", children: "Metric" })] })] }));
};
